import { render, staticRenderFns } from "./rightAD.vue?vue&type=template&id=51a33abd&scoped=true&"
import script from "./rightAD.vue?vue&type=script&lang=js&"
export * from "./rightAD.vue?vue&type=script&lang=js&"
import style0 from "./rightAD.vue?vue&type=style&index=0&id=51a33abd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a33abd",
  null
  
)

export default component.exports